import React from "react";

import { Typography } from "clearsense-ui/components";

import Cell from "./Cell";

const AggregateRow = ({ positives, negatives }) => (
  <tr>
    <td className="p-3 border border-gray-300">
      <Typography className="mr-2 text-right">Total</Typography>
    </td>
    <Cell percent={positives.actual.percent} count={positives.actual.count}>
      <Typography type="semibold" className="-mt-1 -mb-1 text-lg">
        Actual Positives
      </Typography>
    </Cell>
    <Cell percent={negatives.actual.percent} count={negatives.actual.count}>
      <Typography type="semibold" className="-mt-1 -mb-1 text-lg">
        Actual Negatives
      </Typography>
    </Cell>

    <td className="p-6 border border-gray-300">
      <Typography type="semibold" className="mb-2 text-xl">
        {positives.actual.count + negatives.actual.count}
      </Typography>
      <Typography type="semibold" className="text-lg">
        Total responses
      </Typography>
    </td>
  </tr>
);

export default AggregateRow;
